export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/claim.worker.fe6314c4.worker.js");
}
